import Controller from 'controllers/controller';
import Helpers from 'tools/helpers';
import ObjectFit from 'tools/object-fit';

class ObjectFitController extends Controller {
    ready() {
        this.objectFit = new ObjectFit({
            attachEvents: false
        });

        this.attachEvents();
    }
    
    attachEvents() {
        this.app.on('dom-change', this.init);
        this.app.on('resize', this.resize);
        
        window.addEventListener('DOMContentLoaded', this.init);
        window.addEventListener('resize', Helpers.delayedFunction(400, this.init));
    }
    
    resize() {
        this.objectFit.onResize();
    }

    init() {
        this.objectFit.setElements();
        this.objectFit.onResize();
    }
}

export default ObjectFitController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/object-fit.js